import { motion } from "framer-motion";
import './exp.css'
import InAmig from '../Images/inamigos.jfif'

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] } },
};

const ETISALAT_BUILDS = [
    "RAG-based medical chatbot",
    "OCR reader for ID documents + MRZ",
    "AI interview bot (Vapi) with live feedback",
    "Video face-detection with automatic blur",
];

export default function Exp() {
    return (
        <section className="section expWrap">
            <motion.h3 className="sec-label"
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                Experience
            </motion.h3>
            <motion.p className="sec-statement"
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
                It's not just about existence. <span className="mute">It's about impact</span> and cultivating a legacy that transcends time.
            </motion.p>

            <div className="expMasonry">
                {/* Featured: Etisalat AI internship */}
                <motion.div className="expCard expCard--role expCard--feature"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <div className="expRoleTop">
                        <div className="expLogoMark">e&amp;</div>
                        <span className="expOrg">Etisalat &middot; e&amp;</span>
                    </div>
                    <h4 className="expRoleTitle">AI Cognitive Solutions Intern</h4>
                    <div className="expRoleMeta">May 2026 – July 2026 · 2 mos</div>
                    <ul className="expBuilds">
                        {ETISALAT_BUILDS.map((b) => (
                            <li key={b}>{b}</li>
                        ))}
                    </ul>
                </motion.div>

                {/* Stat cards */}
                <motion.div className="expCard expCard--stat"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <span className="expNum">4</span>
                    <p className="expNumDesc">AI applications shipped during my Etisalat internship.</p>
                </motion.div>

                {/* InAmigos (design — secondary) */}
                <motion.div className="expCard expCard--role"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <div className="expRoleTop">
                        <img className="expLogo" src={InAmig} alt="InAmigos Foundation" />
                        <span className="expOrg">InAmigos Foundation</span>
                    </div>
                    <h4 className="expRoleTitle">UX &amp; Graphic Designer</h4>
                    <div className="expRoleMeta">May 2025 – June 2025 · 2 mos</div>
                </motion.div>

                <motion.div className="expCard expCard--stat"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <span className="expNum expNum--word">UX</span>
                    <p className="expNumDesc">Google-certified in User Experience design.</p>
                </motion.div>
            </div>
        </section>
    )
}
